var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFiltreEffacer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer",
    height: 22,
    viewBox: "0 0 24 24",
    width: 22,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "filter-times",
    d: "m20 4.5v2.26a1.5 1.5 0 0 1 -.44 1.06l-.06.06a.288.288 0 0 1 -.21.09.5.5 0 0 1 -.12-.02 5.491 5.491 0 0 0 -5.3 9.561.292.292 0 0 1 .128.24v3.249l-4-3v-4a1.5 1.5 0 0 0 -.44-1.062l-5.118-5.118a1.5 1.5 0 0 1 -.44-1.062v-2.258a1.5 1.5 0 0 1 1.5-1.5h13a1.5 1.5 0 0 1 1.5 1.5zm-3 4.5a4 4 0 1 0 4 4 4 4 0 0 0 -4-4zm1.35 4.65a.483.483 0 0 1 0 .7.483.483 0 0 1 -.7 0l-.65-.64-.65.64a.483.483 0 0 1 -.7 0 .483.483 0 0 1 0-.7l.64-.65-.64-.65a.495.495 0 1 1 .7-.7l.65.64.65-.64a.495.495 0 1 1 .7.7l-.64.65z",
    fill: "rgb(0,0,0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiltreEffacer);
export default __webpack_public_path__ + "static/media/filtre-effacer.e6fb5ce4f69e089161d544a8a51a34f0.svg";
export { ForwardRef as ReactComponent };